import {
    EventID,
    EventMap,
    IService,
    Listener,
    Event,
    SystemComponentType,
    IAsyncEventDecorator
} from '@gongxigames/framework/core/types';
import {consoleLogger} from '@gongxigames/framework/core';

/**
 * responsible for dispatching async events
 * async events - are special type of event that fires after _logic and render phases
 * used mostly for changing the state of the game
 */
export class AsyncEventDecorator implements IAsyncEventDecorator, IService {
    public type: SystemComponentType = 'service';
    protected _asyncEventMap: EventMap = {};
    protected _emittedEvents: Event[] = [];

    public dispatchAsyncEvents(): void {
        for (const {id, args} of this._emittedEvents) {
            const listeners: Listener[] = this._asyncEventMap[id];
            const eventName = (typeof id === 'symbol') ? id.description : id;

            consoleLogger.log('⚡︎ EVENT ASYNC:', eventName);

            if (listeners) {
                for (const listener of listeners) {
                    listener.callback(...args);
                }
            }
        }

        this._emittedEvents.length = 0;
    }

    public addEvent(id: EventID, ...args: any[]): void {
        this._emittedEvents.push({id, args});
    }

    public get asyncEventMap(): {} {
        return this._asyncEventMap;
    }

    public destroy(): void {
        this._asyncEventMap = {};
        this._emittedEvents = [];
    }
}
